import styled from 'styled-components';
import {teamMemberPhoto} from '../../../../assets/symbols/images/teamMemberPhoto';
import {BGImageCenter, LIGHT_BROWN, WHITE2, tabletMedia, dFlexCenter, scrollbar} from '../../../../globalVariables/GlobalVariables';
import {dFlexColumn, alignCenter, justifyBetween, alignStart} from '../../../../globalVariables/GlobalFlex';
import {LIGHT_GRAY5, DARK_GREEN} from '../../../../globalVariables/GlobalVariables';

export const wrapper=styled.div`
    ${dFlexColumn}
    ${justifyBetween}
    ${alignStart}
    position: relative;
    border-radius: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    background: ${LIGHT_BROWN} 0% 0% no-repeat padding-box;
    width: 100%;
    height: calc(100% - 262px);
    padding: 10px;
    padding-top: 20px;
    ${tabletMedia}{
        width: calc(100% - 40px);
        max-height: calc(100vh - 170px);
        margin-inline: 20px;
    }
`;

export const profile = styled.div`
    height: 35px;
    width: 35px;
    ${BGImageCenter(teamMemberPhoto,'contain')}
    border-radius: 50%;
    border: 2px double white;
`; 

export const messageContainer = styled.div`
    position: relative;
    ${scrollbar}
    width: 100%;
    max-width: 260px;
    min-height: 120px;
    max-height: max-content;
    border-radius: 10px;
    background: ${WHITE2} 0% 0% no-repeat padding-box;
    padding: 10px;
`;
export const image = styled.img`
    width: 100%;
    max-height: 100px;
    object-fit: contain;
    border-radius: 10px;
    margin-bottom: 10px;
`;
export const text=styled.div`
    font-size: 12px;
    white-space: pre-line;

    strong {
        font-weight: bold;
    }

    em {
        font-style: italic;
    }
`;

export const title=styled.div`
    width: 100%;
    height: 62px;
    background: ${DARK_GREEN} 0% 0% no-repeat padding-box;
    display: flex;
    align-items: center;
    border-radius: 10px 10px 0 0;
    color: white;
    padding: 10px;
    font-size: 17px;
    gap: 10px;
    ${tabletMedia}{
        width: calc(100% - 40px);
        margin-inline: 20px;
    }
`;

export const buttonContainer = styled.div`
  ${dFlexColumn}
  ${alignCenter}
  gap: 8px;
  margin-top: 18px;
`;

export const linkButton = styled.a`
  color: var(--primitive-turquoise-700);
  font-size: 16px;
  text-decoration: none;
  ${dFlexCenter}
  gap: 4px;
  cursor: pointer;
  font-weight: 400;
  background: none;
  width: 100%;
  text-align: center;
  padding: var(--space-sm) 0;
  border-top: 1px solid ${LIGHT_GRAY5};
  &:last-child {
    border-bottom: 1px solid ${LIGHT_GRAY5};
    margin-bottom: var(--space-sm);
  }
`;

export const time = styled.div`
    color: rgba(0, 0, 0, 0.50);
    text-align: end;
    font-size: 8.78px;
`;
